import { render } from "./AddClient.vue?vue&type=template&id=5ed7ee9d&ts=true"
import script from "./AddClient.vue?vue&type=script&lang=ts"
export * from "./AddClient.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__